// V2-START : toggle Avec/Sans pochette
(function () {
  // Trouve l'input "Sans" via le texte de son label — robuste aux valeurs d'option variables
  function findSansInput(pochetteFieldset) {
    return Array.from(pochetteFieldset.querySelectorAll('input[data-option-position]'))
      .find(function (input) {
        const label = pochetteFieldset.querySelector(
          'label[for="' + input.id + '"]'
        );
        return label && label.textContent.includes('Sans');
      });
  }

  // --- Clic sur les boutons toggle — délégation stable sur body ---
  document.body.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-pochette]');
    if (!btn) return;

    const form = btn.closest('variant-picker')?.closest('form')
               ?? document.querySelector('form[is="product-form"]');
    if (!form) return;

    const variantPicker = document.querySelector(
      'variant-picker[form-id="' + form.getAttribute('id') + '"]'
    );
    const pochetteFieldset = variantPicker?.querySelector('.variant-picker__option-pochette');
    if (!pochetteFieldset) return;

    if (btn.dataset.pochette === 'sans') {
      const input = findSansInput(pochetteFieldset);
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      const sansInput = findSansInput(pochetteFieldset);
      if (!sansInput) return;
      const pochetteInputs = pochetteFieldset.querySelectorAll(
        'input[data-option-position][name="' + sansInput.name + '"]'
      );
      const firstColor = Array.from(pochetteInputs).find(function (i) {
        return i !== sansInput;
      });
      if (firstColor && !firstColor.checked) {
        firstColor.checked = true;
        firstColor.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });

  // --- Masquage/affichage swatches + sync état toggle ---
  function applyPochetteState(form) {
    if (!form) return;
    const formId = form.getAttribute('id');
    const variantPicker = document.querySelector(
      'variant-picker[form-id="' + formId + '"]'
    );
    const pochetteFieldset = variantPicker?.querySelector('.variant-picker__option-pochette');
    if (!pochetteFieldset) return;

    // Masque le swatch "Sans pochette" — toujours caché, géré par le toggle
    const sansInput = findSansInput(pochetteFieldset);
    if (sansInput) {
      const sansLabel = pochetteFieldset.querySelector(
        'label[for="' + sansInput.id + '"]'
      );
      if (sansLabel) sansLabel.style.display = 'none';
    }

    const swatchRow = pochetteFieldset.querySelector('.variant-picker__option-values');
    const titleRow  = pochetteFieldset.querySelector('.variant-picker__option-title');
    const isSans = !!(sansInput && sansInput.checked);
    if (swatchRow) swatchRow.style.display = isSans ? 'none' : '';
    if (titleRow)  titleRow.style.display  = isSans ? 'none' : '';
    pochetteFieldset.querySelectorAll('[data-pochette]').forEach(function (btn) {
      btn.classList.toggle('active', (btn.dataset.pochette === 'sans') === isSans);
    });
  }

  // product:rerender est dispatché sur le form (pas bubble) — capture requis
  document.body.addEventListener('product:rerender', function (event) {
    const form = event.target.closest('form') ?? event.target;
    // Attend la fin du swap DOM avant d'appliquer l'état
    requestAnimationFrame(function() {
      applyPochetteState(form);
    });
  }, true);

  // Init au chargement
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('form[is="product-form"]').forEach(applyPochetteState);
  });
})();
// V2-END
